import { useCallback, useState } from 'react';

import { httpPatch } from 'lib/networking/http';

function usePatch(url, successCallback, errorCallback) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const patchData = useCallback(
    postBody => {
      setLoading(true);
      httpPatch(url, postBody)
        .then(res => successCallback && successCallback(res))
        .catch(error => {
          setError(error);
          errorCallback && errorCallback(error);
        })
        .finally(() => setLoading(false));
    },
    [errorCallback, successCallback, url],
  );

  return { patchData, loading, error };
}

export default usePatch;
